<tm-dialog [open]="(activeComponent$ | async) !== null"
           [width]="panelWidth"
           [widthMargin]="panelWidthMargin"
           (closeDialog)="closeDialog()"
           [dialogTitle]="(activeComponent$ | async)?.dialogTitle || ''">
  <ng-content></ng-content>
</tm-dialog>
